import React, { useEffect, useState } from "react";
import ViewResult from "./ViewResult";
import Swal from "sweetalert2";
import "./MasterQuizList.css";
import API_BASE_URL from "../config/api";

const DASHBOARD_ENDPOINT =
  `${API_BASE_URL}/dashboard_summary.php`;

/* DATE FORMATTER */
const formatStartTime = (raw) => {

  if (!raw) return "—";

  const d = new Date(
    raw.replace(" ", "T")
  );

  if (isNaN(d)) return raw;

  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export default function Last10AttemptsDashboard() {

  const [rows, setRows] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [modalOpen, setModalOpen] =
    useState(false);

  const [
    selectedExamStartId,
    setSelectedExamStartId,
  ] = useState(null);

  /* LOGIN CHECK */
  useEffect(() => {

    const user = JSON.parse(
      sessionStorage.getItem("user")
    );

    if (!user?.id) {

      Swal.fire(
        "Login Required",
        "Please login again",
        "warning"
      ).then(() => {

        window.location.href =
          "/login";

      });

    }

  }, []);

  /* FETCH ATTEMPTS */
  useEffect(() => {

    const user = JSON.parse(
      sessionStorage.getItem("user")
    );

    if (!user?.id) return;

    const controller =
      new AbortController();

    const fetchAttempts = async () => {

      setLoading(true);

      try {

        const res = await fetch(
          `${DASHBOARD_ENDPOINT}?user_id=${user.id}`,
          {
            signal:
              controller.signal,
          }
        );

        const data =
          await res.json();

        console.log(
          "Dashboard API:",
          data
        );

        if (
          data.success &&
          Array.isArray(
            data.lastAttempts
          )
        ) {

          setRows(
            data.lastAttempts
          );

        } else {

          setRows([]);

        }

      } catch (err) {

        if (
          err.name !==
          "AbortError"
        ) {

          console.error(err);

          setRows([]);

        }

      } finally {

        setLoading(false);

      }
    };

    fetchAttempts();

    return () =>
      controller.abort();

  }, []);

  /* LOADING */
  if (loading) {

    return (
      <div className="text-center py-4 text-muted fw-semibold">
        Loading last attempts...
      </div>
    );

  }

  return (
    <>
      <div className="card border-0 shadow-sm rounded-4 p-3 mb-4">

        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">

          {/* LEFT SIDE */}
          <h4 className="mb-0 fw-bold">
            Last 10 Quiz Attempts
          </h4>

          {/* RIGHT SIDE HINT */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "18px",
              flexWrap: "wrap",
              fontSize: "13px",
              color: "#6c757d",
              fontWeight: "500",
            }}
          >

            {/* CORRECT */}
            <div className="d-flex align-items-center gap-2">

              <span
                style={{
                  width: "12px",
                  height: "12px",
                  background: "#22c55e",
                  borderRadius: "50%",
                  display: "inline-block",
                }}
              ></span>

              <span>
                Correct
              </span>

            </div>

            {/* WRONG */}
            <div className="d-flex align-items-center gap-2">

              <span
                style={{
                  width: "12px",
                  height: "12px",
                  background: "#ef4444",
                  borderRadius: "50%",
                  display: "inline-block",
                }}
              ></span>

              <span>
                Wrong
              </span>

            </div>

            {/* NOT ATTEMPTED */}
            <div className="d-flex align-items-center gap-2">

              <span
                style={{
                  width: "12px",
                  height: "12px",
                  background: "#6b7280",
                  borderRadius: "50%",
                  display: "inline-block",
                }}
              ></span>

              <span>
                Not Attempted
              </span>

            </div>

          </div>

        </div>

        {/* TABLE */}
        <div className="table-responsive">

          <table className="table align-middle mb-0">

            <thead
              style={{
                background:
                  "#114c8d",
                color: "#fff",
              }}
            >

              <tr>

                <th
                  className="text-white"
                  style={{
                    width: "70px",
                  }}
                >
                  NO.
                </th>

                <th className="text-white">
                  QUIZ
                </th>

                <th className="text-white text-center">
                  EXAM TYPE
                </th>

                <th className="text-white text-center">
                  ATTEMPTED ON
                </th>

                <th className="text-white text-center">
                  SCORE
                </th>

                <th className="text-white text-center">
                  PERFORMANCE
                </th>

                <th className="text-white text-center">
                  VIEW
                </th>

              </tr>

            </thead>

            <tbody>

              {rows.length === 0 ? (

                <tr>

                  <td
                    colSpan={7}
                    className="text-center py-4 text-muted"
                  >

                    No quiz attempts found

                  </td>

                </tr>

              ) : (

                rows.map((r, i) => {

                  const counts =
                    r.counts || {};

                  const correct =
                    Number(
                      counts.correct
                    ) || 0;

                  const incorrect =
                    Number(
                      counts.wrong
                    ) || 0;

                  const skipped =
                    Number(
                      counts.skipped
                    ) || 0;

                  const notAttempted =
                    (
                      Number(
                        counts.notAttempted
                      ) || 0
                    ) + skipped;

                  const total =
                    Number(
                      counts.total
                    ) || 0;

                  const correctPercent =
                    total > 0
                      ? (
                          (correct /
                            total) *
                          100
                        )
                      : 0;

                  const incorrectPercent =
                    total > 0
                      ? (
                          (incorrect /
                            total) *
                          100
                        )
                      : 0;

                  const notAttemptedPercent =
                    total > 0
                      ? (
                          (notAttempted /
                            total) *
                          100
                        )
                      : 0;

                  return (

                    <tr
                      key={
                        r.start_exam_id
                      }
                    >

                      {/* NO */}
                      <td className="fw-semibold">
                        {i + 1}
                      </td>

                      {/* QUIZ */}
 <td>

  <div className="fw-semibold text-dark">
    {r.subject_name}
  </div>

  {r.chapter_name && (

    <div
      className={
        r.is_subject_exam
          ? "fw-bold text-dark"
          : "small text-muted"
      }
    >

      {!r.is_subject_exam && <>Chapter: </>}

      {r.chapter_name}

    </div>

  )}

</td>
                     
                     {/* EXAM TYPE */}
<td className="text-center">

  <span
    className="badge rounded-pill"
    style={{
      background: r.is_subject_exam
        ? "#1e4f8a"    
        : "#f58220",  

      color: "#fff",

      padding: "10px 18px",

      fontSize: "13px",

      fontWeight: "600",

      border: "none",

      boxShadow:
        "0 2px 8px rgba(0,0,0,0.08)",

      letterSpacing: "0.3px",
    }}
  >

    {r.is_subject_exam
      ? "Master Quiz"
      : "Chapter Quiz"}

  </span>

</td>

                      {/* DATE */}
                      <td className="text-center text-muted">

                        <div
                          className="fw-semibold"
                        >

                          {formatStartTime(
                            r.start_time
                          )}

                        </div>

                        <div className="small">

                          Duration:
                          {" "}
                          {r.duration}

                        </div>

                      </td>

                      {/* SCORE */}
                      <td className="text-center">

                        <div
                          className="fw-bold"
                          style={{
                            fontSize:
                              "20px",
                            color:
                              "#0d6efd",
                          }}
                        >

                          {correct}
                          {" / "}
                          {total}

                        </div>

                        <div className="small text-muted">
                          Correct Score
                        </div>

                      </td>

                      {/* PERFORMANCE */}
                      <td className="text-center">

                        <div
                          style={{
                            minWidth:
                              "280px",
                          }}
                        >

                          {/* CORRECT */}
                          <div
                            className="mb-2"
                            title={`Correct Answers : ${correct}`}
                          >

                            <div
                              className="d-flex justify-content-between align-items-center mb-1"
                            >

                              <span
                                style={{
                                  fontSize:
                                    "12px",
                                  fontWeight:
                                    "600",
                                  color:
                                    "#22c55e",
                                }}
                              >

                                Correct

                              </span>

                              <span
                                style={{
                                  fontWeight:
                                    "700",
                                  fontSize:
                                    "12px",
                                }}
                              >

                                {correct}

                              </span>

                            </div>

                            <div
                              style={{
                                width:
                                  "100%",
                                height:
                                  "8px",
                                background:
                                  "#e5e7eb",
                                borderRadius:
                                  "10px",
                                overflow:
                                  "hidden",
                              }}
                            >

                              <div
                                style={{
                                  width: `${correctPercent}%`,
                                  height:
                                    "100%",
                                  background:
                                    "#22c55e",
                                  transition:
                                    "0.4s",
                                }}
                              ></div>

                            </div>

                          </div>

                          {/* WRONG */}
                          <div
                            className="mb-2"
                            title={`Wrong Answers : ${incorrect}`}
                          >

                            <div
                              className="d-flex justify-content-between align-items-center mb-1"
                            >

                              <span
                                style={{
                                  fontSize:
                                    "12px",
                                  fontWeight:
                                    "600",
                                  color:
                                    "#ef4444",
                                }}
                              >

                                Wrong

                              </span>

                              <span
                                style={{
                                  fontWeight:
                                    "700",
                                  fontSize:
                                    "12px",
                                }}
                              >

                                {incorrect}

                              </span>

                            </div>

                            <div
                              style={{
                                width:
                                  "100%",
                                height:
                                  "8px",
                                background:
                                  "#e5e7eb",
                                borderRadius:
                                  "10px",
                                overflow:
                                  "hidden",
                              }}
                            >

                              <div
                                style={{
                                  width: `${incorrectPercent}%`,
                                  height:
                                    "100%",
                                  background:
                                    "#ef4444",
                                  transition:
                                    "0.4s",
                                }}
                              ></div>

                            </div>

                          </div>

                          {/* NOT ATTEMPTED */}
                          <div
                            title={`Not Attempted : ${notAttempted}`}
                          >

                            <div
                              className="d-flex justify-content-between align-items-center mb-1"
                            >

                              <span
                                style={{
                                  fontSize:
                                    "12px",
                                  fontWeight:
                                    "600",
                                  color:
                                    "#6b7280",
                                }}
                              >

                                Not Attempted

                              </span>

                              <span
                                style={{
                                  fontWeight:
                                    "700",
                                  fontSize:
                                    "12px",
                                }}
                              >

                                {notAttempted}

                              </span>

                            </div>

                            <div
                              style={{
                                width:
                                  "100%",
                                height:
                                  "8px",
                                background:
                                  "#e5e7eb",
                                borderRadius:
                                  "10px",
                                overflow:
                                  "hidden",
                              }}
                            >

                              <div
                                style={{
                                  width: `${notAttemptedPercent}%`,
                                  height:
                                    "100%",
                                  background:
                                    "#6b7280",
                                  transition:
                                    "0.4s",
                                }}
                              ></div>

                            </div>

                          </div>

                        </div>

                      </td>

                      {/* VIEW */}
                      <td className="text-center">

                        <button
                          className="btn btn-link p-0"
                          onClick={() => {

                            setSelectedExamStartId(
                              r.start_exam_id
                            );

                            setModalOpen(
                              true
                            );

                          }}
                        >

                          <i className="bi bi-eye fs-4 text-primary"></i>

                        </button>

                      </td>

                    </tr>

                  );
                })
              )}

            </tbody>

          </table>

        </div>

      </div>

      {/* RESULT MODAL */}
      {modalOpen &&
        selectedExamStartId && (

          <div className="modal-full-overlay">

            <div className="modal-full-content p-3 bg-white position-relative">

              <button
                className="btn-close"
                onClick={() =>
                  setModalOpen(
                    false
                  )
                }
              />

              <ViewResult
                examStartId={
                  selectedExamStartId
                }
              />

            </div>

          </div>

        )}

    </>
  );
}